const USE_LOCAL_SERVER = false;  

const LOCAL_SERVER = "http://127.0.0.1:5002";
const PROD_SERVER = "https://t-api.obriy.ai/live_chat_api";

const CONFIG = {
    SERVER: USE_LOCAL_SERVER ? LOCAL_SERVER : PROD_SERVER,
    SOCKET_IDLE_TIMEOUT: 300000,
    SOCKET_IDLE_CHECK: 30000,
    SOCKET_TRANSPORT: 'websocket', // 'websocket' or 'polling'
    SOCKET_ROUTE: "/s_consumer_channel",
    RPM: 100
};

export default CONFIG;